import Vue from 'vue'
import router from './router'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import './assets/style.scss'
import VueMeta from 'vue-meta'
import * as VueGoogleMaps from 'vue2-google-maps'

const moment = require('moment')
require('moment/locale/ja')

Vue.prototype.$GoogleMapKey = 'AIzaSyAf47-mJtWgTlk-dO5iSavvu0NIpxmR858'
Vue.prototype.$tosUrl = 'https://players1.st/terms'
Vue.prototype.$privacyPolicyUrl = 'https://players1.st/privacy'

Vue.prototype.$tw_consumer_key = 'Q9ZTbE3YerRoFoFGU9aB08R1e'
Vue.prototype.$tw_consumer_secret = 'YMIhYzfcv081xYGJFhjlwho01LyRKJ22L1by5pCa0jqwCEVZil'
Vue.prototype.$tw_access_token_key = '214009107453104128-2UZX6cMIokSLLAjguCeTjnJaigY07J'
Vue.prototype.$tw_access_token_secret = 'ggoiIrGJ1Xkup1G2Yeku8vlSNDGDTA2uF9TqO5I3QklTt'

Vue.config.productionTip = false

Vue.use(VueMeta, {
  // optional pluginOptions
  // refreshOnceOnNavigation: true
})

Vue.use(require('vue-moment'), {
    moment
})

Vue.use(Buefy)

Vue.use(VueGoogleMaps, {
  load: {
    key: Vue.prototype.$GoogleMapKey,
    libraries: 'places'
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
